module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("We are grateful that this book fired the imaginations of so many people along the way and that some of them were willing to go to such great heights for us: particularly Junior Wood of Engwiller Properties, who got the cameraman 50 feet above the sidewalk in a lift; Ken Stockdale from the City of Mansfield, who escorted us to the 10th floor of a nine-story building; and Frank Ujvari of U-Vary Aire, who went clearly above and beyond.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Officer Cecil Burton and the Mansfield Police Department, Lee Hale of Hale’s Harley-Davidson Motorcycles, and Tim Owens and the Mid-Ohio Harley Owners Group all caught the vision and went the extra mile for this project.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("All of these people opened their doors to us: attorney Dan Gerhardt, Johnson Brothers Jewelry and Loan, Mansfield Motor Sports Speedway, Raemelton Therapeutic Equestrian Center, Westbrook Country Club, and Richland Bank. Boyd Addlesperger chased down facts, and Katy Davis domesticated the words.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Jeff Sprang or the author took all of the modern photographs. The historical photographs are from the collection of the Sherman Room at the Mansfield/Richland County Public Library unless otherwise noted.")])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db330dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439640883_ack01.vue
// module id = 75
// module chunks = 0